// extracted by mini-css-extract-plugin
module.exports =  {"features":"_93444fe79c--features--sfe3h","item":"_93444fe79c--item--vYtGr","bg_gray6_100":"_93444fe79c--bg_gray6_100--eWIcm","bg_gray10_100":"_93444fe79c--bg_gray10_100--L1tNm"};